import { post } from '../../helpers/api/post';
import { LOGIN } from '../../helpers/api/apiPaths';
import { AUTHENTICATION_API_SUCCESS, LOGOUT } from './currentUser.reducer';

export const login = (username, password) =>
  post(LOGIN, { username, password })
    .then(
      response => ({ type: AUTHENTICATION_API_SUCCESS, response }),
    );

export const logout = () => ({ type: LOGOUT });



// WEBPACK FOOTER //
// ./src/reducers/currentUser/currentUser.actions.js